import { faCheck, faSave, faTimes } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import React from "react"
import { Button, ButtonGroup, FormControl } from "react-bootstrap"
import ReactTooltip from "react-tooltip"
import categoria, { conCategorias } from "../../../Model/Categoria"
interface Props {
    categoria: categoria
    update?: () => void
}
export class FilaCategoria extends React.Component<Props, categoria> {
    con = conCategorias()

    constructor(p: Props) {
        super(p)
        this.state = p.categoria
    }

    render() {
        let { code, description } = this.props.categoria
        return <tr>
            <th>
                <FormControl defaultValue={code} maxLength={6} onChange={this.setChangeCode.bind(this)} />
            </th>
            <th>
                <ReactTooltip />
                <FormControl defaultValue={description} onChange={this.setChangeDesc.bind(this)} />
            </th>
            <th>
                {this.getStatus()}
            </th>
            <th>
                <ButtonGroup>
                    <Button data-tip="guardar" onClick={this.guardar.bind(this)}>
                        <FontAwesomeIcon icon={faSave} />
                    </Button>
                    {this.getBotton()}
                </ButtonGroup>
            </th>
        </tr>
    }
    getStatus() {
        switch (this.props.categoria.status) {
            case 0:
                return <span className="bg-danger text-white p-1 d-inline-block">inactivo</span>
            case 1:
                return <span className="bg-success text-white p-1 d-inline-block">ACTIVADO</span>
        }
    }
    getBotton() {
        if (this.props.categoria.status === 1)
            return <Button data-tip="INHABILITAR" onClick={this.Eliminar.bind(this)} variant="danger"><FontAwesomeIcon icon={faTimes} /></Button>

        else
            return <Button data-tip="HABILITAR" onClick={this.Activar.bind(this)} variant="success"><FontAwesomeIcon icon={faCheck} /></Button>

    }
    setChangeCode(e: React.ChangeEvent<HTMLSelectElement>) {
        let { value } = e.currentTarget
        let r = value.toUpperCase()
        e.currentTarget.value = r
        this.setState({ code: r })
    }
    setChangeDesc(e: React.ChangeEvent<HTMLSelectElement>) {
        let { value } = e.currentTarget
        let r = value.toUpperCase()
        e.currentTarget.value = r
        this.setState({ description: r })
    }
    guardar() {
        let { code, description, id } = this.state
        this.con.update({ id, code, description, status: 1 }, this.props.update)
    }
    Eliminar() {
        let { id } = this.props.categoria
        this.con.stateChange({ id, status: 0 }, this.props.update)
    }
    Activar() {
        let { id } = this.props.categoria
        this.con.stateChange({ id, status: 1 }, this.props.update)
    }
}